module.exports = __webpack_public_path__ + "media/images/massage/mathieu@2x-bbf7d8c4d9406ed29a1f4717fb2af1d7.jpg";